export const LINKS = {
  VIEWER_LIMITS:
    'https://events-support.ringcentral.com/hc/en-us/articles/360056528631-Max-On-Screen-and-Viewer-Limits',
};
